import { CSSProperties } from 'react';
import { mediaQuery, minBreakpoints } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

import { nothsTheme } from 'src/styles/noths.theme';

export interface CSSVarImage extends CSSProperties {
  '--bgDesktop': string;
  '--bgMobile': string;
}

export interface CSSVarSmallImage extends CSSProperties {
  '--background': string;
}

const { font: nothsFont, color: nothsColor } = nothsTheme;

export const PartnerSubTitle = css`
  font-family: ${nothsFont.family.tertiary};
  font-size: ${nothsFont.size.S};
  line-height: 1;
  font-weight: 400;
  font-style: italic;
  text-align: center;
  -webkit-font-smoothing: antialiased;
  padding: 0;
  margin: 6px 0 50px 0;
  color: ${nothsColor.primary};

  &[data-negative-colors='true'] {
    color: ${nothsColor.white};
  }
`;

export const PartnersRow = css`
  margin: 0 -10px;
`;

export const PartnersBlock = css`
  margin: 0 12px 30px;
  width: 100%;

  :last-child {
    margin-bottom: 0;
  }

  ${mediaQuery(
    { min: minBreakpoints.MEDIUM },
    css`
      width: 100%;
      margin: 0 12px 0;
    `,
  )};
`;

export const PartnersImages = css`
  border-radius: 3px;
  overflow: hidden;
  display: flex;
`;

export const PartnersColumn = css`
  margin-top: 1px;
  margin-left: 0px;
  width: 100%;

  ${mediaQuery(
    { min: minBreakpoints.MEDIUM },
    css`
      margin-top: 0px;
      margin-left: 2px;
    `,
  )};
`;

export const PartnersLargeImage = css`
  display: block;
  width: 100%;
  height: 66vw;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  background-image: var(--bgMobile);
  overflow: hidden;

  ${mediaQuery(
    { min: minBreakpoints.MEDIUM },
    css`
      background-image: var(--bgDesktop);
      height: 330px;

      :hover {
        opacity: 0.9;
      }
    `,
  )};

  > span {
    position: absolute;
    width: 0;
    height: 0;
    left: -99999px;
    overflow: hidden;
  }
`;

export const PartnersSmallImage = css`
  display: block;
  background-size: cover;
  background-repeat: no-repeat;
  background-image: var(--background);
  background-position: center;
  width: 50%;
  height: 44vw;
  overflow: hidden;

  :hover {
    opacity: 1;
  }

  ${mediaQuery(
    { min: minBreakpoints.MEDIUM },
    css`
      width: 100%;
      height: 164px;

      + a {
        margin-top: 2px;
        margin-left: 0px;
      }

      :hover {
        opacity: 0.9;
      }
    `,
  )};

  > span {
    position: absolute;
    width: 0;
    height: 0;
    left: -99999px;
    overflow: hidden;
  }
`;
